import React from 'react';
import {
  FieldType,
  IDataModelFieldTypeInput,
  IFieldTypeParamsInput,
} from '../../../../utils/apollo/graphqlSchema';
import produce from 'immer';
import {
  ARRAY_ITEM_FIELD_TYPE_OPTIONS,
  defaultFieldTypeParamsInput,
} from '../utils';
import InputField from '../../../../components/Form/InputField';
import { StyledTypeOverrideSelectMenu } from './DataModelerCdwTableGridUI';

interface IProps {
  typeInput: IDataModelFieldTypeInput;
  setTypeInput?: (newInput: IDataModelFieldTypeInput) => void;
}

const SelectTypeParamsOverride = ({ typeInput, setTypeInput }: IProps) => {
  const updateTimezone = (newTimezone: string) => {
    const newInput = produce(typeInput, (draft) => {
      const typeParams: IFieldTypeParamsInput =
        draft.typeParams ?? defaultFieldTypeParamsInput();
      typeParams.fixedTz = newTimezone.trim().length > 0 ? newTimezone : null;
      draft.typeParams = typeParams;
      return draft;
    });
    setTypeInput?.(newInput);
  };

  const updateArrayItemType = (newType: string) => {
    const newInput = produce(typeInput, (draft) => {
      const typeParams: IFieldTypeParamsInput =
        draft.typeParams ?? defaultFieldTypeParamsInput();
      typeParams.arrayItemType = newType as FieldType;
      draft.typeParams = typeParams;
      return draft;
    });
    setTypeInput?.(newInput);
  };

  return (
    <>
      {typeInput.type === FieldType.Timestamp && (
        <>
          TZ:
          <InputField
            autoComplete="off"
            name="tzname"
            value={typeInput.typeParams?.fixedTz ?? ''}
            onChange={updateTimezone}
            placeholder={'None'}
            disabled={!setTypeInput}
          />
        </>
      )}
      {(typeInput.type === FieldType.Array ||
        typeInput.type === FieldType.ArrayObject) && (
        <>
          Items type:{' '}
          <StyledTypeOverrideSelectMenu
            value={typeInput.typeParams?.arrayItemType}
            options={ARRAY_ITEM_FIELD_TYPE_OPTIONS}
            onChange={updateArrayItemType}
            disabled={!setTypeInput}
          />
        </>
      )}
    </>
  );
};

export default SelectTypeParamsOverride;
